import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web"; // Required to access Keycloak instance
import ApplicationRoutes from "./Routes";           // Make sure this file exists
import "./App.css";                                 // Optional, but assumed to be in use

function App() {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (keycloak?.authenticated) {
      const refreshInterval = setInterval(() => {
        keycloak.updateToken(60).catch(() => {
          keycloak.logout({ redirectUri: window.location.origin });
        });
      }, 60000); // every 60s

      return () => clearInterval(refreshInterval);
    }
  }, [keycloak]);

  if (!initialized) return <div>Loading authentication...</div>;

  if (!keycloak.authenticated) {
    keycloak.login();
    return null;
  }

  return <ApplicationRoutes />;
}

export default App; // This was missing
